import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { SelectOption } from '../interfaces/select-option';
import { map, Observable, tap } from 'rxjs';
import { CreateThemeDto, Theme } from '../interfaces/theme';
import { ApiResponse } from '../interfaces/responses/api-response';

@Injectable({
  providedIn: 'root',
})
export class SelectOptionsService {
  private baseUrl = `${environment.BASE_URL}/themes`;

  constructor(private http: HttpClient) {}

  // Créer une nouvelle option (utilisée par custom-select)
  createOption(title: string): Observable<Theme> {
    console.log('Creating option with title:', title);
    return this.createThemeFromTitle(title, 1).pipe(
      tap({
        next: (theme) => console.log('Option created successfully:', theme),
        error: (error) => console.error('Error creating option:', error),
      }),
    );
  }

  getOptions(subjectId: number): Observable<Theme[]> {
    return this.http
      .get<
        ApiResponse<Theme[]>
      >(`${environment.BASE_URL}/learnings/subjects/${subjectId}/themes`)
      .pipe(
        map((response) => response.data), // Extraire uniquement le Theme
      );
  }

  // Nouvelle méthode simplifiée pour le custom-select
  // Elle prend juste le titre et les autres paramètres requis
  createThemeFromTitle(
    title: string,
    subjectId: number,
    displayOrder: number = 0,
  ): Observable<Theme> {
    const dto: CreateThemeDto = {
      title: title,
      description: '', // Description vide par défaut
      subjectId: subjectId,
      displayOrder: displayOrder,
      isActive: true, // Actif par défaut
    };

    return this.http
      .post<ApiResponse<Theme>>(`${environment.BASE_URL}/learnings/themes`, dto)
      .pipe(
        map((response) => response.data), // Extraire uniquement le Theme
      );
  }
}
